
// Modern method: simulate a click on the Shopify Chat button when the link is clicked
(function() {
  function openShopifyChat(retriesLeft) {
    // Try to find the chat button in the DOM
    // Try to find the chat button in the DOM or in the shadow DOM of the custom element
    var chatButton = document.querySelector('#ShopifyChat button[aria-controls="chat-ui"], #ShopifyInboxWidgetLauncher, .shopify-chat-button');
    if (!chatButton) {
      // Try to find the custom element and its shadow DOM button
      var chatWidget = document.querySelector('inbox-online-store-chat#ShopifyChat');
      if (chatWidget && chatWidget.shadowRoot) {
        // Try to find a button inside the shadow root
        chatButton = chatWidget.shadowRoot.querySelector('button, [role="button"]');
        if (chatButton) {
          console.log('[ShopifyChat Debug] Found chat button in shadow DOM:', chatButton, chatButton.outerHTML);
        }
      }
    }
    if (chatButton) {
      console.log('[ShopifyChat Debug] Found chat button:', chatButton, chatButton.outerHTML);
      chatButton.click();
      return true;
    } else {
      console.log('[ShopifyChat Debug] No chat button found with selectors at this attempt. Retries left:', retriesLeft);
    }
    // Fallback: try inside an iframe (rare)
    var iframe = document.querySelector('iframe#dummy-chat-button-iframe');
    if (iframe && iframe.contentWindow && iframe.contentWindow.document) {
      var buttonInFrame = iframe.contentWindow.document.querySelector('button');
      if (buttonInFrame) {
        console.log('[ShopifyChat Debug] Found chat button in iframe:', buttonInFrame, buttonInFrame.outerHTML);
        buttonInFrame.click();
        return true;
      } else {
        console.log('[ShopifyChat Debug] No chat button found in iframe.');
      }
    }
    // Retry if not found yet
    if (retriesLeft > 0) {
      setTimeout(function() {
        openShopifyChat(retriesLeft - 1);
      }, 250);
    } else {
      console.warn('[ShopifyChat Debug] Gave up after retries. No chat button found.');
    }
    return false;
  }
  document.addEventListener('DOMContentLoaded', function() {
    var chatLinks = document.querySelectorAll('a[href="#open-chat"], #shopify-chat-trigger');
    if (!chatLinks.length) return;
    chatLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        openShopifyChat(20); // Retry for up to 5 seconds
      });
      link.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openShopifyChat(20);
        }
      });
    });
  });
})();
